module.exports = __webpack_public_path__ + "static/media/gb-wls.4ae3736e.svg";